/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {isEmpty} from '../../../../utilities/validation';
/* eslint-enable no-unused-vars */

import classnames from 'classnames';

class BookSidebar extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {selectedIndex = 0, sections = []} = this.props;

        return (
           <div className="book-sidebar">
                {sections.length > 0 && this.renderSelectBox()}
                {sections.length > 0 && this.renderSection(sections[selectedIndex])}
            </div>
        );
    }

    /**
     * Compare against a list of section titles and return true if any of them match the current/selected page.
     */
    findAnySectionTitlesOnSelectedPage(sectionTitleCandidateList = []) {
        const {selectedPageNum = 0, sections = [], selectedSectionId = 0} = this.props;
        const section = sections.find(section => section.id === selectedSectionId);

        return section && section.pages && section.pages[selectedPageNum - 1] && sectionTitleCandidateList.includes(
            section.pages[selectedPageNum - 1].title.toLowerCase());
    }

    renderSelectBox() {
        const {selectedIndex = 0, sections = [], changeSection = null, selectedPageNum, sectionComplete = false,
            sectionTitle='', role, submitting} = this.props;

        const disableSelectBox = (
            !sectionComplete
            && (sectionTitle.includes('Section') || sectionTitle.includes('Session') && !sectionTitle.includes('Session 6'))
            && role === 'student'
            && (isEmpty(selectedPageNum) || this.findAnySectionTitlesOnSelectedPage(['module guide', 'post test']) ||
                ((parseInt(selectedPageNum) === 1 || parseInt(selectedPageNum) === 0) &&
                    !this.findAnySectionTitlesOnSelectedPage(['intro'])))
        );

        return (
            <select value={sections[selectedIndex].title}
                    disabled={disableSelectBox || submitting}
                    onChange={changeSection} className="section-select">
                {
                    sections.map((section) => {
                        return <option
                            key={`section-${section.id}`}
                            value={section.title}>
                            {section.title}
                        </option>;
                    })
                }
            </select>
        );
    }

    renderSection(section) {
        return (
            <div className="pagelist" id={section.id}>
            {section.title == "Session 6" &&
            <a href="https://robo-review.nolaedu.net/" target="_blank"
            >
                 Robo-Review
            </a>}
                {
                    section.pages.map((page, index) => {
                        return this.renderPage(page, section, index);
                    })
                }
            </div>
        );
    }

    renderPage(page, section, index) {
  const {role = '', assignmentId = '', bookId, selectedPageNum,
  sectionComplete = false,extendedContentId, extendedContentModified, extendedContentEditing,
            submitting} = this.props;
        let {latestPage = 0} = this.props;
        let pageNum = parseInt(index) + 1;
        if(parseInt(selectedPageNum) > parseInt(latestPage)) {
            latestPage = parseInt(selectedPageNum);
        }
        let link = (
            <Link
                className="dim"
                to="#"
            >
                {page.title}
            </Link>
        );

        if(window.contentparams[8] >= pageNum) {
           link = (
               <Link className="book-sidebar" to={`/view/modules/${bookId}/assignments/${assignmentId}/sections/${section.id}/pages/${pageNum}`}>
                   {page.title}
               </Link>
           );
       }


        if(sectionComplete || latestPage >= pageNum) {
            link = (
                <Link
                    className={classnames({active: parseInt(selectedPageNum) === pageNum})}
                    to={`/view/modules/${bookId}/assignments/${assignmentId}/sections/${section.id}/pages/${pageNum}`}
                >
                    {page.title}
                </Link>
            );
        }

        if(role === 'student') {
            return (
                <div key={`page-${page.id}`}>
                    { link }
                </div>
            );
        }
        else {
          let toUrl = `/view/modules/${bookId}/assignments/${assignmentId}/sections/${section.id}/pages/${pageNum}`;
          if (extendedContentId){
              toUrl = `/view/modules/${bookId}/assignments/${assignmentId}/sections/${section.id}/pages/${pageNum}/extendid/${extendedContentId}`;
          }

          if (extendedContentModified && extendedContentEditing || submitting) {
              return (
                  <div key={`page-${page.id}`} >
                      <button className={classnames({active: parseInt(selectedPageNum) === pageNum}, 'jre-sidebar-change-page', {dim:submitting})}
                              value={page.id} disabled={submitting}
                              onClick={() => this.props.handleButtonClick(pageNum)}
                      >
                          {page.title}
                      </button>
                  </div>
              );
          }else{
              return (
                  <div key={`page-${page.id}`}>
                      <Link className={classnames({active: parseInt(selectedPageNum) === pageNum})}
                            to={{pathname: toUrl, search: this.context.router.history.location.search}}>
                          {page.title}
                      </Link>
                  </div>
              );
          }
        }
    }
}

BookSidebar.contextTypes = {
    router: PropTypes.object.isRequired
};

BookSidebar.propTypes = {
    sections: PropTypes.array.isRequired,
    bookId: PropTypes.string.isRequired,
    selectedSectionId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    selectedPageNum: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired
};

export default BookSidebar;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/book-sidebar.js